{
  "module": "STANDS",
  "upgradeCode": "STANDS_5000",
  "configurationToken": "cfg-tok-mock-stands-5000",
  "ruleSetVersion": 1,
  "quotedCost": 3500000.0,
  "stadiumVersion": 1,
  "durationMatchdays": 1,
  "fromLevel": 2,
  "toLevel": 3,
  "capacity": 50000
}
